import { FC } from 'react';

import { Page, PageHeader } from '@/components';
import { withLoader, WithLoaderProps } from '@/hocs';
import InternalAffairsTable from '@/pages/Tools/InternalAffairs/Tables/InternalAffairsTable';

const InternalAffair: FC<WithLoaderProps> = () => {
  return (
    <Page>
      <PageHeader title="Internal Affairs" backRoute="/tools" />

      <InternalAffairsTable />
    </Page>
  );
};

export default withLoader(InternalAffair);
